import {Navigate, useLocation} from "react-router-dom";
import {useContext} from "react";
import AuthContext from "context/AuthContext";
import {SwalAlertClass} from "core/swalClass";

const PrivateRoute = ({children, role, panelType}) => {
    const location = useLocation();
    const {user, panel} = useContext(AuthContext);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});

    // Obtiene la ruta actual completa, incluyendo los query params
    const currentPath = location.pathname + location.search;

    // Verificar permisos basados en roles si se especifica un rol
    let hasPermission = true;

    if (user && role) {
        switch (role) {
            case "tech":
                // Si el rol mínimo es tech, cualquiera con tech o superior puede acceder
                hasPermission = user.is_superuser || user.is_admin || user.is_tech;
                break;
            case "admin":
                // Si el rol mínimo es admin, solo admin o superuser pueden acceder
                hasPermission = user.is_superuser || user.is_admin;
                break;
            case "superuser":
                // Si el rol mínimo es superuser, solo superuser puede acceder
                hasPermission = user.is_superuser;
                break;
            default:
                hasPermission = false;
        }
    }

    if (!hasPermission) {
        Alert.error(
            "Acceso denegado",
            "No tienes permisos para acceder a esta sección"
        );
    }

    if (!user) {
        return (
            <Navigate
                to={`/login/?next=${encodeURIComponent(currentPath)}`}
                replace={true}
            />
        );
    }

    if (!user.organization || !user.panel) {
        return <Navigate to="/notorgpanel/" replace={true} />;
    }

    // Redirigir si no tiene permisos
    if (role && !hasPermission) {
        return <Navigate to="/" replace />;
    }

    // Redirigir si el tipo de panel no coincide
    if (panelType && panel?.panel_type !== panelType) {
        return <Navigate to="/" replace />;
    }

    // Permitir acceso si tiene permisos
    return children;
};

export default PrivateRoute;
